export default __webpack_public_path__ + "static/media/wallet.de0ab213.svg";